module.exports = __webpack_public_path__ + "img/rg_old1.4bc7911b.png";